import {
  Typography,
  Grid,
  TextField,
} from '@material-ui/core';
import {
  Button,
} from '@roc/ui';
import { useState } from 'react';

interface CommentDialogProps {
  onClose: () => void;
  subTitle: string;
  input: any;
  onSubmit: any;
  includeCommentBox?: boolean;
}

const PayoffReconciliationCommentDialog = ({ onClose, subTitle, input, onSubmit, includeCommentBox = true }: CommentDialogProps) => {
  const [comment, setComment] = useState<string>(input? input : '');

  const handleSaveOnComment = () =>{
    onSubmit(comment);
    onClose();
  }
  const handleChange = () => (event: React.ChangeEvent<HTMLInputElement>) =>{
    setComment(event.target.value);
  }

  return (
    <Grid container justifyContent="center" spacing={3}>
      <Grid item xs={12}>
        <Typography variant="body2">
          {subTitle}
        </Typography>
      </Grid>
      {includeCommentBox && (
        <Grid item xs={12}>
          <TextField variant="outlined" fullWidth onChange={handleChange()} value={comment} label={"Comment"} name={"Type here..."}>
          </TextField>
        </Grid>
      )}
      <Grid item container justifyContent="center">
        <Grid item xs={3} style={{ padding: '0px 4px 0px 4px' }}>
          <Button
            variant="outlined"
            size="medium"
            onClick={() => onClose()}
            color="primary"
            testId="Comment_Cancel"
            fullWidth={true}
            style={{ padding: '2px 0px 2px 0px' }}
          >
            Cancel
          </Button>
        </Grid>
        <Grid item xs={3} style={{ padding: '0px 4px 0px 4px' }}>
          <Button
            variant="contained"
            size="medium"
            onClick={() => handleSaveOnComment()}
            color="primary"
            testId="Comment_Save"
            fullWidth={true}
            style={{ padding: '2px 0px 2px 0px' }}
          >
            Confirm
          </Button>
        </Grid>
      </Grid>
    </Grid>
  )
};
export default PayoffReconciliationCommentDialog;
